import { style } from "@vanilla-extract/css";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "@huub-web/ui/theme/css/theme.css";

const BREAKPOINT = 700;

export const cardStyle = style({});

export const cardInnerStyle = style({
  // borderTopLeftRadius: 0,
});

export const cardContentStyle = style({
  gap: 0,
  paddingBottom: "var(--padding)",
});

export const bannerCardInnerStyle = style({
  borderRadius: theme.borderRadiuses.s,
});

export const trackStrokeStyle = style({
  stroke: theme.colors.defaultBorder,
});

export const gaugeStyle = style({
  flexShrink: 0,
});

export const bannerCardContentStyle = style({
  alignItems: "flex-start",
  gap: theme.spacings.s,
  flexDirection: "column",
  ...responsiveContainer({
    [BREAKPOINT]: {
      flexDirection: "row",
      gap: theme.spacings.l,
    },
  }),
});

export const totalCostStyle = style({
  borderTop: `1px solid ${theme.colors.defaultBorder}`,
  marginTop: theme.spacings.xxs,
  paddingTop: theme.spacings.xs,
});

export const cardTabsStyle = style({
  zIndex: 3,
  position: "relative",
  marginBottom: rem(-10),
  paddingLeft: rem(16),
  paddingRight: rem(16),
  justifyContent: "center",
});

export const slideContainerStyle = style({
  padding: "var(--padding)",
  gap: theme.spacings.m,
});
